import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, List, Popup, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ItemIcon from '../ItemIcon';
import InfoIcon from '../InfoIcon';
import SimpleModelViewer from '../model-viewer/SimpleModelViewer';
import Model from '../model-viewer/Model';

export default class AppearanceCard extends Component {
    render() {
        const {appearance} = this.props;
        const {CanCraft, CanBuy, CanLoot, FromQuest, HasCostume} = appearance;

        const model = new Model({appearance: appearance});

        const quickLook = <Popup trigger={<Button icon="eye" />}
                                 content={<SimpleModelViewer appearanceId={appearance.Id} model={model} compact={true} width='300px'/>}
                            flowing
                            hoverable
                            position="left center"
                            />
        return (
            <Card key={appearance.Id}>
                <Card.Content>
                    <ItemIcon image={appearance.Icon} floated='left' />
                    <Card.Header>
                        <Link to={`/appearances/${appearance.Id}`}>
                            {appearance.Name.English}
                        </Link>
                    </Card.Header>
                    <Card.Meta>{appearance.Type}</Card.Meta>
                </Card.Content>
                <Card.Content extra>
                    <List horizontal divided>
                        <List.Item>
                            {quickLook}
                        </List.Item>
                        <List.Item>
                            <FontAwesomeIcon icon="tshirt" /> {appearance.TotalItems}
                        </List.Item>
                        <List.Item>
                            <InfoIcon icon={['fab','pied-piper-hat']} isEnabled={HasCostume} tooltip='This appearance can be acquired from a costume' />
                        </List.Item>
                        <List.Item>
                            <InfoIcon icon="coins" isEnabled={CanBuy} tooltip='This appearance can be aquired from an item that is sold by a vendor' />
                        </List.Item>
                        <List.Item>
                            <InfoIcon icon="wrench" isEnabled={CanCraft} tooltip='This appearance can be acquired from an item that is craftable' />
                        </List.Item>
                        <List.Item>
                            <InfoIcon icon="hand-rock" isEnabled={CanLoot} tooltip='This appearance can be acquired from an item that is bind on equip' />
                        </List.Item>
                        <List.Item>
                            <InfoIcon icon="check-circle" isEnabled={FromQuest} tooltip='This appearance can be acquired from an item that is a quest reward' />
                        </List.Item>
                    </List>
                </Card.Content>
            </Card>
        )
    }
}

AppearanceCard.propTypes = {
    appearance: PropTypes.object.isRequired,
};


// WEBPACK FOOTER //
// ./src/common/appearances/AppearanceCard.jsx